<template>
  <!-- 咨询室 -->
  <div class="consulting-room" activityFrom="咨询室">
    <div class="video-wrapper">
      <!-- 全屏容器 -->
      <div class="fullscreen-container" ref="fullscreenContainer" :class="{ 'is-fullscreen': isFullscreen }" @mousemove="handleMouseMove" @mouseleave="hideControls">
        <!-- 视频容器 -->
        <div class="video-container" ref="videoContainer">
          <div v-show="detailData.isShutByManager === 0 && screenType !== 'sub'" class="large-screen" ref="refLargeScreen"></div>
          <div v-show="detailData.isShutByManager === 0 && screenType === 'sub'" class="large-screen" ref="refSubScreen"></div>
          <div v-show="detailData.isShutByManager === 1" class="large-screen kicked-out">
            <div class="kicked-out-reason">
              <div>
                <el-image :src="require('../../../assets/consultingRoom/tip_error.png')" style="width: 32px;height: 32px;"/>
                当前咨询室疑似违规已被关闭
              </div>
              <div>
                具体可查看行为记录
              </div>
            </div>
          </div>
        </div>
        <!-- 控制条 -->
        <transition name="fade">
          <div
            class="controls-bar"
            v-show="showControls && isFullscreen"
            @mouseenter="showControls = true"
            @mouseleave="startHideTimer"
          >
            <div class="controls-content">
              <!-- 其他控制按钮可以放在这里 -->
              <div class="exit-fullscreen-btn" @click="handleFullScreen">
                <el-image :src="require('@/assets/consultingRoom/tcqp.png')" style="width: 32px;height: 32px;"/>
                {{ isFullscreen ? '退出全屏' : '全屏' }}
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div class="large-screen-action">
        <div class="action-left">
          <div class="action-btn-item">
            <div class="action-btn" @click="handleMic">
              <el-image v-if="displayMicStatus" :src="require('@/assets/consultingRoom/open_mic.png')" class="btn-icon"/>
              <el-image v-else :src="require('@/assets/consultingRoom/close_mic.png')" class="btn-icon"/>
              <div>
                麦克风
              </div>
            </div>
            <div class="action-btn-more">
              <el-popover
                v-model="micPopoverVisible"
                placement="top"
                trigger="click"
                width="500px"
              >
                <div class="custom-popover-select">
                  <div class="custom-popover-select-option" v-for="mic in micList.filter(item=>item.deviceId !== 'default')" @click="handleSelectMic(mic)">
                    <span>{{mic.label}}</span>
                    <span v-if="curMicId === mic.deviceId" class="el-icon-check"></span>
                  </div>
                </div>
                <span class="el-icon-arrow-up" slot="reference"></span>
              </el-popover>
            </div>
          </div>
          <div class="action-btn-item">
            <div class="action-btn" @click="handleCamera">
              <!--              <span :class="displayCameraStatus ? 'el-icon-video-camera' : 'el-icon-turn-off-microphone'" class="btn-icon" />-->
              <el-image v-if="displayCameraStatus" :src="require('@/assets/consultingRoom/open_camera.png')" class="btn-icon"/>
              <el-image v-else :src="require('@/assets/consultingRoom/off_camera.png')" class="btn-icon"/>
              <div>
                摄像头
              </div>
            </div>
            <div class="action-btn-more">
              <el-popover
                v-model="cameraPopoverVisible"
                placement="top"
                trigger="click">
                <div class="custom-popover-select">
                  <div class="custom-popover-select-option" v-for="camera in cameraList" @click="handleSelectCamera(camera)">
                    <span>{{camera.label}}</span>
                    <span v-if="curCameraId === camera.deviceId" class="el-icon-check"></span>
                  </div>
                </div>
                <span class="el-icon-arrow-up" slot="reference"></span>
              </el-popover>
            </div>
          </div>
          <div class="action-btn" @click="handleShareScreen">
            <el-image :src="require('@/assets/consultingRoom/gxpm.png')" class="btn-icon"/>
            <div>
              {{!shareScreenStatus ? '共享屏幕' : '停止共享'}}
            </div>
          </div>
          <div class="action-btn" @click="handleFullScreen">
            <el-image :src="require('@/assets/consultingRoom/qp.png')" class="btn-icon"/>
            <div>
              全屏
            </div>
          </div>
          <div class="action-btn" @click="handleInvite">
            <el-image :src="require('@/assets/consultingRoom/yq.png')" class="btn-icon"/>
            <div>
              邀请
            </div>
          </div>
        </div>
        <div class="action-right">
          <div class="action-btn" @click="handleMember">
            <el-image :src="require('@/assets/consultingRoom/cy.png')" class="btn-icon"/>
            <div>
              成员
            </div>
          </div>
          <div class="action-btn" @click="handleChat">
            <el-image :src="require('@/assets/consultingRoom/lt.png')" class="btn-icon"/>
            <div>
              聊天
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="member-row">
      <div class="member-screen-container">
        <div class="member-screen">
          <div class="page-title">成员画面</div>
          <div class="screen-container">  <!-- 新增容器 -->
            <div class="screen-content">
              <template v-for="(data, dataIndex) in memberScreenList">
                <div class="screen-item" v-if="data.userId" :key="dataIndex">
                  <div class="item-video" :class="`remote_video_${data.userId}_${data.streamType}`" :ref="el => setVideoRef(el, data)"></div>
                  <div class="user-row">
                    <div class="user-icon" v-if="data.userId === detailData.consultantUserId">
                      <el-image style="border-radius: 50%;" :src="data.headPicUrl"/>
                    </div>
                    <div class="user-name">
                      <span v-if="data.userId === detailData.consultantUserId">
                        {{data.nickName}}
                      </span>
                      <span v-else-if="data.userId === detailData.consulterId">
                        预约人 {{data.phone.slice(-4) || ''}}
                      </span>
                      <span v-else-if="data.isManage === true || data.isMange === 1">
                        运营 {{data.phone.slice(-4) || ''}}
                      </span>
                      <span v-else>
                        {{data.phone.slice(-4) || ''}}
                      </span>
                    </div>
                    <div class="user-action">
                      <el-image @click="handleSelectUserScreen('EXIT_FULL',data,dataIndex,true)" v-if="selectedUserScreen === data.userId" :src="require('@/assets/consultingRoom/tcqp.png')" />
                      <el-image @click="handleSelectUserScreen('FULL',data,dataIndex,true)" v-else :src="require('@/assets/consultingRoom/yhqp.png')" />
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="member-list" v-if="memberListVisible">
        <div class="sub-title">
          <div>
            成员（{{memberCount}}）
          </div>
          <div>
            <span class="el-icon-close" @click="memberListVisible = !memberListVisible"/>
          </div>
        </div>
        <div class="member-items-container">
          <div class="member-item" v-for="(member, memberIndex) in memberScreenList" :key="memberIndex">
            <template v-if="member.userId">
              <div class="member-head">
                <div v-if="member.userId === detailData.consultantUserId" class="member-head-icon">
                  <el-image style="border-radius: 50%;" :src="member.headPicUrl"/>
                </div>
                <span v-if="member.userId === $store.state.UserInfo.id && member.userId !== detailData.consultantUserId" style="color: #5AD3CD;">我 </span>
              </div>
              <div class="member-name">
                <div v-if="member.userId === detailData.consultantUserId">
                  {{member.nickName}}
                </div>
                <div v-else-if="member.userId === detailData.consulterId">
                  预约人 {{member.phone.slice(-4) || ''}}
                </div>
                <div v-else-if="member.isManage === true || member.isMange === 1">
                  运营 {{member.phone.slice(-4) || ''}}
                </div>
                <div v-else>
                  {{member.phone.slice(-4) || ''}}
                </div>
                <div v-if="member.userId === detailData.consultantUserId" style="color: #5AD3CD;">房主</div>
              </div>
              <div class="member-action">
                <el-image
                  v-if="($store.state.UserInfo.id === detailData.consultantUserId || $store.state.UserInfo.id === member.userId)&& member.handStatus === true" :src="require('@/assets/consultingRoom/list_hand.png')"
                  class="btn-icon"
                />
                <el-image
                  v-if="member.userId !== detailData.consultantUserId && ($store.state.UserInfo.id === detailData.consultantUserId || $store.state.UserInfo.isManage === true)"
                  :src="member.micStatus ? listOpenMicImg : listCloseMicImg"
                  class="btn-icon"
                  @click="handleListMic(member,memberIndex)"
                />
                <el-image
                  v-if="member.userId !== detailData.consultantUserId && ($store.state.UserInfo.id === detailData.consultantUserId || $store.state.UserInfo.isManage === true)"
                  :src="member.cameraStatus ? listOpenCameraImg : listCloseCameraImg"
                  class="btn-icon"
                  @click="handleListCamera(member,memberIndex)"
                />
              </div>
            </template>
          </div>
        </div>
        <div v-if="$store.state.UserInfo.id === detailData.consultantUserId || $store.state.UserInfo.isManage === true" class="member-list-footer">
          <el-button type="primary" class="custom-button" @click="handleAllMic">{{allAudioStatus === 'open' ? '全体静音' : '解除静音'}}</el-button>
          <el-button type="primary" class="custom-button" @click="handleAllCamera">{{allCameraStatus === 'open' ? '全体静画' : '解除静画'}}</el-button>
        </div>
        <div v-else-if="canModifyMic === false" class="member-list-footer">
          <el-button
            type="primary"
            class="custom-button"
            @click="handleHand(memberScreenList.find(item => item.userId === $store.state.UserInfo.id))"
          >{{memberScreenList.find(item => item.userId === $store.state.UserInfo.id).handStatus === false ? '举手' : '放下手'}}</el-button>
        </div>
      </div>
      <div class="chat-list" v-if="chatListVisible">
        <div class="sub-title">
          <div>
            聊天
            <el-button v-if="messageData.length > 5" type="primary" plain class="view-all" @click="handleViewAll">查看全部</el-button>
          </div>
          <div>
            <span class="el-icon-close" @click="handleChat"/>
          </div>
        </div>
        <div ref="chatContainerRef" class="chat-container" @scroll="handleChatScroll">
          <div v-for="(mes,mesIndex) in messageData" :key="mesIndex">
            <div v-if="mes.currentUserSendFlag === 0" class="chat-item other">
              <div class="avatar-row-other-user">
                <el-avatar v-if="mes.userId === detailData.consultantUserId" icon="el-icon-user-solid" :src="mes.headPicUrl"/>
                <div class="user-name">{{mes.name}}</div>
              </div>
              <div class="message-content-other-user">
                <el-image class="icon-top" :src="require('@/assets/consultingRoom/mesContentOther.png')"/>
                {{mes.content}}
              </div>
            </div>
            <div v-else class="chat-item current">
              <div class="avatar-row-current-user">
                <el-avatar v-if="mes.userId === detailData.consultantUserId" icon="el-icon-user-solid" :src="mes.headPicUrl"/>
                <div class="user-name">{{mes.name}}</div>
              </div>
              <div class="message-content-current-user">
                <el-image class="icon-top" :src="require('@/assets/consultingRoom/mesContentCurrent.png')"/>
                {{mes.content}}
              </div>
            </div>
          </div>
        </div>
        <div class="chat-send-row">
          <!-- 新消息提示（只在有未读新消息时显示） -->
          <div
            v-if="showNewMessageTip"
            class="new-message-tip"
            @click="scrollToBottom"
          >
            有新消息，点击查看
          </div>
          <el-input class="send-input" v-model="sendMessage" maxlength="200" clearable/>
          <el-button :class="['send-button',sendMessage ? 'has-message':'no-message']" @click="handleSendMessage">发送</el-button>
        </div>
      </div>
    </div>
    <!--  邀请弹窗  -->
    <el-dialog :visible="inviteDialogVisible" @close="inviteDialogVisible = false" :show-close="false" custom-class="invite-dialog">
      <div class="invite-info-container">
        <div class="invite-url">
          {{inviteUrl}}
        </div>
        <div>
          <el-button class="copy-btn" @click="handleCopyUrl">复制</el-button>
        </div>
      </div>
      <div class="invite-title">
        邀请链接
        <div class="invite-prompt">
          (发送给对方，即可通过链接进入咨询室）
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TRTC from 'trtc-sdk-v5';
import {
  consultMeetingHealth,
  consultMeetingMessage,
  describe,
  getUserEmployeeInfoById,
  messageList,
  switchCamera, switchMicrophone
} from '@/api/consultingRoom'
import { TRTCErrorHandler } from '@/utils/trtc-error-handler'
import FullscreenMixin from '@/utils/FullscreenMixin'
export default {
  name: 'consultingRoom',
  mixins: [FullscreenMixin],
  data() {
    return {
      listOpenMicImg: require('@/assets/consultingRoom/list_open_mic.png'),
      listCloseMicImg: require('@/assets/consultingRoom/list_close_mic.png'),
      listOpenCameraImg: require('@/assets/consultingRoom/list_open_camera.png'),
      listCloseCameraImg: require('@/assets/consultingRoom/list_close_camera.png'),
      // 错误处理相关状态
      deviceError: {
        microphone: false,
        camera: false
      },
      // 咨询室详情
      detailData: {},
      userSig: '',
      // 被踢原因
      kickedOutReason: '',
      // 麦克风状态
      micStatus: true,
      // 麦克风列表
      micList: [],
      // 麦克风选中id
      curMicId: '',
      micPopoverVisible: false,
      // 摄像头状态
      cameraStatus: false,
      // 摄像头列表
      cameraList: [],
      // 摄像头选中id
      curCameraId: '',
      cameraPopoverVisible: false,
      // 共享屏幕状态
      shareScreenStatus: false,
      // 是否全屏
      isFullscreen: false,
      showControls: false,
      hideDelay: 3000, // 3秒后隐藏控制条
      prevScrollPosition: {x: 0, y: 0},
      // 视频SDK实例
      trtc: null,
      // 邀请弹窗-显示状态
      inviteDialogVisible: false,
      // 邀请弹窗-链接文本
      inviteUrl: '',
      memberScreenList: [
        {
          userId: '',
          userType: '承约人',
          userName: '承约人昵称',
          streamType: 'main',
          micStatus: true,
          cameraStatus: false
        },
        {
          userId: '',
          userType: '预约人',
          userName: '预约人昵称',
          streamType: 'main',
          micStatus: true,
          cameraStatus: false,
          handStatus: false
        }
      ],
      // 成员列表-显示状态
      memberListVisible: false,
      // 聊天列表-显示状态
      chatListVisible: false,
      hideTimer: null,
      screenType: '',
      // 当前选择大屏展示的用户
      selectedUserScreen: '',
      // 当前大屏显示的用户ID和流类型
      largeScreenUser: {
        userId: '',
        streamType: ''
      },
      // 全体音频状体
      allAudioStatus: 'open',
      // 全体视频状态
      allCameraStatus: 'open',
      // 麦克风状态
      remoteMicStatus: 'open',
      // 摄像头状态
      remoteCameraStatus: 'open',
      // 当前登陆人信息
      userInfo: {},
      // 要发送的信息内容
      sendMessage: '',
      // 聊天室信息数据
      messageData: [],
      // 聊天室获取数据定时器
      getMessageListInterval: null,
      // 定时更新 实时消耗定时起
      refreshConsumeInterval: null,
      // 进房后定时心跳
      joinRoomInterval: null,

      // 最后一条消息的ID
      lastMessageTime: null,
      // 是否应该自动滚动
      shouldAutoScroll: true,
      // 是否显示新消息提示
      showNewMessageTip: false,
      scrollDebounceTimer: null,
      // 距离底部的阈值（像素）
      scrollThreshold: 50,
      // 记录上次滚动位置，用于判断滚动方向
      lastScrollTop: 0,
    }
  },
  computed: {
    // 计算属性用于确定麦克风icon显示状态
    displayMicStatus() {
      if (this.micList.length === 0) {
        return false
      }
      // if(this.detailData.status !== 2) {
      //   return false
      // }
      if (this.$store.state.UserInfo.id === this.detailData.consultantUserId || this.$store.state.UserInfo.isManage === true) {
        return this.micStatus
      }
      if (this.allAudioStatus === 'close' && this.detailData.allMicrophoneTurnedOffFlag === 1) {
        return false
      } else {
        if (this.remoteMicStatus === 'close') {
          return false
        } else {
          return this.micStatus
        }
      }
    },
    // 计算属性用于确定用户是否可以修改状态
    canModifyMic() {
      if (this.$store.state.UserInfo.id === this.detailData.consultantUserId || this.$store.state.UserInfo.isManage === true) {
        return true
      } else {
        if (this.allAudioStatus === 'close' && this.detailData.allMicrophoneTurnedOffFlag === 1) {
          return false
        } else {
          if (this.remoteMicStatus === 'open') {
            return true
          } else {
            return false
          }
        }
      }
    },
    // 计算属性用于确定麦克风icon显示状态
    displayCameraStatus() {
      if (this.cameraList.length === 0) {
        return false
      }
      // if(this.detailData.status !== 2) {
      //   return false
      // }
      if (this.$store.state.UserInfo.id === this.detailData.consultantUserId || this.$store.state.UserInfo.isManage === true) {
        return this.cameraStatus
      }
      if (this.allCameraStatus === 'close' && this.detailData.allCameraTurnedOffFlag === 1) {
        return false
      } else {
        if (this.remoteCameraStatus === 'close') {
          return false
        } else {
          return this.cameraStatus
        }
      }
    },
    // 计算属性用于确定用户是否可以修改状态
    canModifyCamera() {
      if (this.$store.state.UserInfo.id === this.detailData.consultantUserId || this.$store.state.UserInfo.isManage === true) {
        return true
      } else {
        if (this.allCameraStatus === 'close' && this.detailData.allCameraTurnedOffFlag === 1) {
          return false
        } else {
          if (this.remoteCameraStatus === 'open') {
            return true
          } else {
            return false
          }
        }
      }
    },
    memberCount() {
      let count = 2
      console.log('this.memberScreenList = ', this.memberScreenList)
      if (this.memberScreenList[0] && this.memberScreenList[0].userId) {
        count -= 1
      }
      if (this.memberScreenList[1] && this.memberScreenList[1].userId) {
        count -= 1
      }
      console.log('count = ', count)
      return this.memberScreenList.length - count
    },
  },
  mounted() {
    this.getDetail()
    const loginUserInfo = this.$store.state.UserInfo
    console.log('loginUserInfo = ', loginUserInfo)
    if (!this.refreshConsumeInterval) {
      this.intervalRefreshConsume()
    }
    if (!this.joinRoomInterval) {
      this.intervalJoinRoom()
    }
  },
  methods: {
    // 统一的错误处理方法
    handleError(error, operation = '操作', customMessage = null) {
      const errorMessage = TRTCErrorHandler.showError(error, this, customMessage);

      // 根据错误类型更新设备状态
      if (TRTCErrorHandler.isPermissionError(error)) {
        if (operation.includes('麦克风') || operation.includes('音频')) {
          this.deviceError.microphone = true;
        } else if (operation.includes('摄像头') || operation.includes('视频')) {
          this.deviceError.camera = true;
        }
      }

      if (TRTCErrorHandler.isDeviceNotFoundError(error)) {
        if (operation.includes('麦克风') || operation.includes('音频')) {
          this.deviceError.microphone = true;
          this.$message.warning('麦克风设备未找到，请检查设备连接');
        } else if (operation.includes('摄像头') || operation.includes('视频')) {
          this.deviceError.camera = true;
          this.$message.warning('摄像头设备未找到，请检查设备连接');
        }
      }

      return errorMessage;
    },
    async getDetail(unInitTrtc) {
      try {
        // 获取视屏详情
        const detailRes = await describe(this.$route.query.appointmentId)
        console.log('detailRes = ', detailRes)
        if (detailRes && detailRes.code === 200) {
          this.detailData = detailRes.data
          this.allAudioStatus = !this.detailData.allMicrophoneTurnedOffFlag || this.detailData.allMicrophoneTurnedOffFlag === 0 ? 'open' : 'close'
          this.allCameraStatus = !this.detailData.allCameraTurnedOffFlag || this.detailData.allCameraTurnedOffFlag === 0 ? 'open' : 'close'
          this.$emit('dataUpdate', detailRes.data);
          // 判断是否重新初始化 插件
          if (unInitTrtc === true) {
            return
          }
          // 校验用户是否有咨询室访问权限权限
          const curUserId = this.$store.state.UserInfo.id
          if (
            curUserId !== this.detailData.consultantUserId &&
            curUserId !== this.detailData.consulterId &&
            this.$store.state.UserInfo.isManage !== true &&
            this.$route.query.invite_code !== this.detailData.inviteCode
          ) {
            if (this.trtc) {
              await this.trtc.exitRoom();
            }
            await this.$router.push({
              path: '/consultingService'
            })
          } else {
            // 根据会议id 和 邀请码 调用 进入房间 接口
            const joinRoomParams = {
              appointmentId: this.detailData.appointmentId,
              inviteCode: this.$route.query.invite_code || undefined
            }
            const joinRoomRes = await consultMeetingHealth(joinRoomParams)
            if (!joinRoomRes.data.sign) {
              if (this.trtc) {
                await this.trtc.exitRoom();
              }
              if (joinRoomRes.msg !== '该会议已被关闭') {
                this.$message.warning(joinRoomRes.msg)
                await this.$router.push({
                  path: '/consultingService'
                })
              } else {
                // this.destroyRoom()
              }
            } else {
              // 返回 userSig  后，开始初始化 TRTC sdk
              console.log('joinRoomRes = ', joinRoomRes)
              this.userSig = joinRoomRes.data.sign
              // const userListRes = await queryAttendRecords(this.detailData.meetingId)
              // console.log('userListRes = ', userListRes)
              const userInfoRes = await getUserEmployeeInfoById()
              this.userInfo = userInfoRes.data
              if (this.userInfo.userId === this.detailData.consultantUserId) { // 判断是否是受询人
                this.$set(this.memberScreenList, 0, {
                  ...this.userInfo,
                  streamType: 'main',
                  micStatus: false,
                  cameraStatus: false,
                  isManage: this.$store.state.UserInfo.isManage
                })
              } else if (this.userInfo.userId === this.detailData.consulterId) { // 判断是否是预约人
                this.$set(this.memberScreenList, 1, {
                  ...this.userInfo,
                  streamType: 'main',
                  handStatus: false,
                  micStatus: false,
                  cameraStatus: false,
                  isManage: this.$store.state.UserInfo.isManage
                })
              } else {
                this.memberScreenList.push({
                  ...this.userInfo,
                  streamType: 'main',
                  handStatus: false,
                  micStatus: false,
                  cameraStatus: false,
                  isManage: this.$store.state.UserInfo.isManage
                })
              }
              console.log('memberScreenList = ', this.memberScreenList)
              console.log('userInfo ', this.userInfo)
              this.$nextTick(async () => {
                // 咨询室状态为 2 进行中 时，初始化 音视频组件 TODO
                if(this.detailData.status === 2 && this.detailData.isShutByManager === 0) {
                  await this.initTRTC(this.userInfo.userId.toString(), this.userSig, this.detailData.meetingId)
                }
              })
            }
          }
        }
      } catch (error) {
        this.handleError(error, '获取咨询室详情');
      }
    },

    async initTRTC(userId, userSig, roomId) {
      try {
        const sdkAppId = 1600102091;
        // const streamType = 'main'
        console.log('初始化TRTC:', {sdkAppId, userId, userSig, roomId});
        if (this.trtc) {
          await this.trtc.exitRoom()
          await this.trtc.destroy()
        }
        // 创建TRTC实例
        this.trtc = TRTC.create({
          // 开启 SEI 收发功能
          enableSEI: true
        });

        // 绑定事件监听 - 使用 TRTC.EVENT 枚举
        this.bindTRTCEvents();
        const enterRoomParams = {
          sdkAppId,
          userId,
          userSig,
          roomId,
          role: 'anchor',
          streamConfig: {
            audio: true,
            video: false,
            screen: false
          },
          enableAutoPlayDialog: false
        }
        console.log('enterRoomParams = ', enterRoomParams)
        // 加入房间
        await this.trtc.enterRoom(enterRoomParams);
        console.log('成功加入房间');

        // 获取设备列表
        try {
          this.micList = await TRTC.getMicrophoneList()
          this.curMicId = this.micList[0]?.deviceId || ''
          console.log("麦克风列表 = ", this.micList)
          if (this.micList.length === 0 || (this.micList.length === 1 && !this.micList[0].deviceId)) {
            this.micStatus = false
            this.micList = []
          }
          this.cameraList = await TRTC.getCameraList()
          console.log("摄像头列表 = ", this.cameraList)
          this.curCameraId = this.cameraList[0]?.deviceId || ''
          if (this.cameraList.length === 0 || (this.cameraList.length === 1 && !this.cameraList[0].deviceId)) {
            this.cameraStatus = false
            this.cameraList = []
          }
        } catch (error) {
          this.handleError(error, '获取设备列表');
        }

        if (this.$store.state.UserInfo.id === this.detailData.consultantUserId || this.$store.state.UserInfo.isManage === true || (this.detailData.allMicrophoneTurnedOffFlag === 0 && this.displayMicStatus)) {
          // 启动并发布本地音视频
          await this.trtc.startLocalAudio();
          const index = this.memberScreenList.findIndex(item => item.userId === Number(this.$store.state.UserInfo.id));
          if (index !== -1) {
            this.$set(this.memberScreenList[index], 'micStatus', !this.memberScreenList[index].micStatus);
          }
        }
        this.cameraStatus = false

        this.$nextTick(() => {
          // 承约人视角：总是尝试显示预约人（如果有的话）
          if (this.$store.state.UserInfo.id === this.detailData.consultantUserId) {
            // 如果有预约人且在线，就显示到大屏
            const consulateUser = this.memberScreenList.find(
              item => item.userId === this.detailData.consulterId
            );

            if (consulateUser && consulateUser.userId) {
              // 先设置大屏显示预约人，即使摄像头还没打开
              this.selectedUserScreen = consulateUser.userId;
              this.largeScreenUser = {
                userId: consulateUser.userId.toString(),
                streamType: 'main'
              };

              // 设置一个延迟检查，确保视频能正确显示
              setTimeout(() => {
                this.handleSelectUserScreen('FULL', consulateUser, true);
              }, 1000);
            }
          } else if (this.$store.state.UserInfo.id === this.detailData.consulterId) {// 预约人视角：总是显示承约人
            const consultantUser = this.memberScreenList.find(
              item => item.userId === this.detailData.consultantUserId
            );

            if (consultantUser && consultantUser.userId) {
              this.selectedUserScreen = consultantUser.userId;
              this.largeScreenUser = {
                userId: consultantUser.userId.toString(),
                streamType: 'main'
              };

              setTimeout(() => {
                this.handleSelectUserScreen('FULL', consultantUser, true);
              }, 1000);
            }
          } else {
            const consultantUser = this.memberScreenList.find(// 其他用户视角：显示承约人
              item => item.userId === this.detailData.consultantUserId
            );

            if (consultantUser && consultantUser.userId) {
              this.selectedUserScreen = consultantUser.userId;
              this.largeScreenUser = {
                userId: consultantUser.userId.toString(),
                streamType: 'main'
              };

              setTimeout(() => {
                this.handleSelectUserScreen('FULL', consultantUser, true);
              }, 1000);
            }
          }
        });
      } catch (error) {
        this.handleError(error, '初始化TRTC');
      }
    },

    // 绑定TRTC事件 - 使用 TRTC.EVENT 枚举
    bindTRTCEvents() {
      // 移除之前的事件监听（避免重复绑定）
      this.trtc.off('*');

      // 监听远端用户加入事件
      this.trtc.on(TRTC.EVENT.REMOTE_USER_ENTER, async (event) => {
        console.log('远端用户加入:', event);
        const {userId} = event
        try {
          const userInfoRes = await getUserEmployeeInfoById({userId})
          console.log('远端用户进房后 userInfoRes = ', userInfoRes)
          if (userId === this.detailData.consultantUserId.toString()) { // 判断是否是受询人
            this.$set(this.memberScreenList, 0, {
              ...userInfoRes.data,
              streamType: 'main',
              cameraStatus: this.allCameraStatus === 'open',
              micStatus: this.allAudioStatus === 'open'
            })
          } else if (userId === this.detailData.consulterId.toString()) { // 判断是否是预约人
            this.$set(this.memberScreenList, 1, {
              ...userInfoRes.data,
              streamType: 'main',
              cameraStatus: this.allCameraStatus === 'open',
              micStatus: this.allAudioStatus === 'open'
            })
          } else {
            this.memberScreenList.push({
              ...userInfoRes.data,
              streamType: 'main',
              cameraStatus: this.allCameraStatus === 'open',
              micStatus: this.allAudioStatus === 'open'
            })
          }
        } catch (error) {
          this.handleError(error, '获取远端用户信息');
        }
      });

      // 监听远端用户离开事件
      this.trtc.on(TRTC.EVENT.REMOTE_USER_EXIT, (event) => {
        console.log('远端用户离开:', event);
        const {userId} = event
        if (Number(userId) === this.selectedUserScreen) {
          this.selectedUserScreen = ''
        }
        const index = this.memberScreenList.findIndex(item => item.userId === Number(userId));
        if (index !== -1) {
          this.$set(this.memberScreenList[index], 'userId', '');
        }
        // 从成员画面列表中移除
        if (Number(userId) !== this.detailData.consultantUserId && Number(userId) !== this.detailData.consultantId) {
          this.memberScreenList = this.memberScreenList.filter(
            member => member.userId.toString() !== event.userId
          );
        }
        console.log('this.memberScreenList = = = ', this.memberScreenList)
      });

      // 监听远端视频可用事件
      this.trtc.on(TRTC.EVENT.REMOTE_VIDEO_AVAILABLE, async (event) => {
        console.log('event = ', event)
        const {userId, streamType} = event;
        console.log('远端视频可用:', {userId, streamType});
        console.log('远端用户进房后 = ', this.memberScreenList)
        this.$nextTick(async () => {
          try {
            // 查找对应的视频容器并播放
            if (streamType === 'sub') {
              if (this.isFullscreen || this.isIOSFullscreen) {
                // 先退出全屏
                await this.exitFullscreen(this.$refs.refLargeScreen);

                // 等待一小段时间确保DOM状态更新
                await new Promise(resolve => setTimeout(resolve, 200));
              }
              this.screenType = streamType
              await this.trtc.startRemoteVideo({userId, streamType, view: this.$refs['refSubScreen']});
              await this.enterFullscreen(this.$refs.refSubScreen, this.largeScreenUser.userId);
            } else {
              if (this.largeScreenUser.userId === userId) {
                this.trtc.startRemoteVideo({
                  userId,
                  streamType,
                  view: this.$refs['refLargeScreen'],
                  option: {
                    small: false
                  }
                });
              } else {
                const containerId = `remote_video_${userId}_${streamType}`;
                this.trtc.startRemoteVideo({
                  userId,
                  streamType,
                  view: this.$refs[containerId],
                  option: {
                    small: '480p'
                  }
                });
              }
            }
            // const index = this.memberScreenList.findIndex(item => {
            //   return item.userId === Number(userId);
            // });
            // if (index !== -1) {
            //   this.$set(this.memberScreenList[index], 'cameraStatus', !this.memberScreenList[index].cameraStatus);
            // } TODO
            console.log('aaaaaa = this.memberScreenList = ', this.memberScreenList)
            this.$nextTick(() => {
              // 当前用户是 承约人，并且预约人userId存在，就将预约人视频放大到主屏幕，这里不发送信息，仅本地切换
              if (this.$store.state.UserInfo.id === this.detailData.consultantUserId && this.memberScreenList[1].userId && this.memberScreenList[1].cameraStatus) {
                this.handleSelectUserScreen('FULL', this.memberScreenList[1], true)
              }
              // 当前用户是 预约人，并且承约人userId存在，就将承约人视频放大到主屏幕，这里不发送信息，仅本地切换
              if (this.$store.state.UserInfo.id === this.detailData.consulterId && this.memberScreenList[0].userId && this.memberScreenList[0].cameraStatus) {
                this.handleSelectUserScreen('FULL', this.memberScreenList[0], true)
              }
              // 当前用户是既不是承约人，又不是预约人，就将承约人视频放大到主屏幕，这里不发送信息，仅本地切换
              if (this.$store.state.UserInfo.id !== this.detailData.consultantUserId && this.$store.state.UserInfo.id !== this.detailData.consulterId && this.memberScreenList[0].userId && this.memberScreenList[0].cameraStatus) {
                this.handleSelectUserScreen('FULL', this.memberScreenList[0], true)
              }
            })
          } catch (error) {
            this.handleError(error, '播放远端视频');
          }
        })
      });
      // 监听远端视频不可用事件
      this.trtc.on(TRTC.EVENT.REMOTE_VIDEO_UNAVAILABLE, async (event) => {
        const {userId, streamType} = event;
        console.log('远端视频不可用:', {userId, streamType});

        if (streamType === 'sub') {
          // 屏幕共享停止，重置 screenType
          this.screenType = '';
          console.log('屏幕共享已停止');
          // 先退出全屏
          await this.exitFullscreen(this.$refs.refSubScreen);
          console.log('--- this. -- -', this.largeScreenUser)
          if (this.largeScreenUser.userId) {
            const isLocalUser = this.largeScreenUser.userId === this.$store.state.UserInfo.id;
            this.selectedUserScreen = this.largeScreenUser.userId;
            const video = this.$refs.refLargeScreen.querySelector('video')
            if (isLocalUser) {
              if (!video) {
                // 在大屏启动本地视频
                await this.trtc.startLocalVideo({
                  view: this.$refs.refLargeScreen,
                });
              } else {
                // 在大屏启动本地视频
                await this.trtc.updateLocalVideo({
                  view: this.$refs.refLargeScreen,
                });
              }

            } else {
              if (!video) {
                await this.trtc.startRemoteVideo({
                  view: this.$refs.refLargeScreen,
                  userId: this.largeScreenUser.userId.toString(),
                  streamType: this.largeScreenUser.streamType,
                  option: {
                    profile: {
                      width: 1920,
                      height: 1080,
                      frameRate: 24,
                      bitrate: 4000,
                    }
                  }
                });
              } else {
                await this.trtc.updateRemoteVideo({
                  view: this.$refs.refLargeScreen,
                  userId: this.largeScreenUser.userId.toString(),
                  streamType: this.largeScreenUser.streamType,
                  option: {
                    profile: {
                      width: 1920,
                      height: 1080,
                      frameRate: 24,
                      bitrate: 4000,
                    }
                  }
                });
              }
            }
          }
        }
      });
      // 监听远端音频可用事件
      this.trtc.on(TRTC.EVENT.REMOTE_AUDIO_AVAILABLE, async (event) => {
        const {userId, streamType} = event;
        console.log('远端音频可用:', {userId, streamType});
        const index = this.memberScreenList.findIndex(item => item.userId === Number(userId));
        if (index !== -1) {
          // this.$set(this.memberScreenList[index], 'micStatus', !this.memberScreenList[index].micStatus); TODO 确认是否 和远程用户的 麦克风状态取消关联
        }
      });
      // 监听远端音频不可用事件
      this.trtc.on(TRTC.EVENT.REMOTE_AUDIO_UNAVAILABLE, async (event) => {
        const {userId, streamType} = event;
        console.log('远端音频可用:', {userId, streamType});
        const index = this.memberScreenList.findIndex(item => item.userId === Number(userId));
        if (index !== -1) {
          // this.$set(this.memberScreenList[index], 'micStatus', !this.memberScreenList[index].micStatus); TODO 确认是否 和远程用户的 麦克风状态取消关联
        }
      });
      this.trtc.on(TRTC.EVENT.AUTOPLAY_FAILED, event => {
        const userId = Number(event.userId)
        const params = {
          userId: userId,
          streamType: 'main'
        }
        // 当前用户是 承约人，并且预约人userId存在，就将预约人视频放大到主屏幕，这里不发送信息，仅本地切换
        if (this.$store.state.UserInfo.id === this.detailData.consultantUserId) {
          if (userId === this.detailData.consulterId) {
            this.handleSelectUserScreen('FULL', params, true)
          } else {
            this.handleSelectUserScreen('SMALL', params, true)
          }
        }
        // 当前用户是 预约人，并且承约人userId存在，就将承约人视频放大到主屏幕，这里不发送信息，仅本地切换
        if (this.$store.state.UserInfo.id === this.detailData.consulterId) {
          if (userId === this.detailData.consultantUserId) {
            this.handleSelectUserScreen('FULL', params, true)
          } else {
            this.handleSelectUserScreen('SMALL', params, true)
          }
        }
        // 当前用户是既不是承约人，又不是预约人，就将承约人视频放大到主屏幕，这里不发送信息，仅本地切换
        if (this.$store.state.UserInfo.id !== this.detailData.consultantUserId && this.$store.state.UserInfo.id !== this.detailData.consulterId) {
          if (userId === this.detailData.consultantUserId) {
            this.handleSelectUserScreen('FULL', params, true)
          } else {
            this.handleSelectUserScreen('SMALL', params, true)
          }
        }
      });
      // 监听错误事件
      this.trtc.on(TRTC.EVENT.ERROR, (error) => {
        console.error('TRTC错误:', error);
        this.handleError(error, 'TRTC操作');
      });
      // 自定义消息
      this.trtc.on(TRTC.EVENT.CUSTOM_MESSAGE, async event => {
        // event.userId: 远端发消息的 userId
        // event.cmdId: 您自定义的消息 Id
        // event.seq: 消息的序号
        // event.data: 消息内容，ArrayBuffer 类型
        console.log('接收到消息了 === ', event)
        const params = JSON.parse(new TextDecoder().decode(event.data))
        const remoteUserId = params.userId
        console.log('params = ', params)
        if (event.cmdId === 1) { // 全体静音
          const operationType = params.allMicStatus
          if (operationType === 1) {
            await this.trtc.stopLocalAudio();
            this.allAudioStatus = 'close'
            this.$message.warning('全员的麦克风已被房主关闭')
          } else {
            const lastStatus = JSON.parse(JSON.stringify(this.displayMicStatus))
            this.allAudioStatus = 'open'
            this.micStatus = lastStatus
            this.$message.warning('房主已解除了对全员麦克风的关闭')
          }
        }
        if (event.cmdId === 2) { // 全体静画
          const operationType = params.allCameraStatus
          if (operationType === 1) {
            await this.trtc.stopLocalVideo()
            this.allCameraStatus = 'close'
            this.$message.warning('全员的摄像头已被房主关闭')
          } else {
            const lastStatus = JSON.parse(JSON.stringify(this.displayCameraStatus))
            this.allCameraStatus = 'open'
            this.cameraStatus = lastStatus
            this.$message.warning('房主已解除了对全员摄像头的关闭')
          }
        }
        if (event.cmdId === 3) { // 强制操作指定人员麦克风
          if (remoteUserId === this.userInfo.userId) {
            if (params.micStatus === false) {
              await this.trtc.stopLocalAudio();
              this.remoteMicStatus = 'close'
              this.$message.warning('您的麦克风已被房主关闭')
            } else {
              const lastStatus = JSON.parse(JSON.stringify(this.displayMicStatus))
              this.micStatus = lastStatus
              this.remoteMicStatus = 'open'
              this.$message.warning('房主已解除了对您麦克风的关闭')
              this.$set(this, 'allAudioStatus', 'open')
              const index = this.memberScreenList.findIndex(item => {
                return item.userId === this.$store.state.UserInfo.id
              });
              if (index !== -1) {
                this.$set(this.memberScreenList[index], 'handStatus', false);
              }
            }
          }
        }
        if (event.cmdId === 4) { // 强制操作指定人员摄像头
          console.log('remoteUserId = ', remoteUserId)
          if (remoteUserId === this.$store.state.UserInfo.id) {
            if (params.cameraStatus === false) {
              await this.trtc.stopLocalVideo()
              this.remoteCameraStatus = 'close'
              this.$message.warning('您的摄像头已被房主关闭')
            } else {
              const lastStatus = JSON.parse(JSON.stringify(this.displayCameraStatus))
              this.remoteCameraStatus = 'open'
              this.cameraStatus = lastStatus
              this.$set(this, 'allCameraStatus', 'open')
              this.$message.warning('房主已解除了对您摄像头的关闭')
            }
          }
        }
        if (event.cmdId === 5 && (this.$store.state.UserInfo.id === this.detailData.consultantUserId || this.$store.state.UserInfo.isManage === true)) {
          // this.memberScreenList.find(item => item.userId === remoteUserId).handStatus = params.handStatus
          const index = this.memberScreenList.findIndex(item => item.userId === remoteUserId);
          if (index !== -1) {
            this.$set(this.memberScreenList[index], 'handStatus', params.handStatus);
          }
        }
        console.log(`received custom msg from ${event.userId}, message: ${new TextDecoder().decode(event.data)}`)
      })

      // 监听被踢出房间
      this.trtc.on(TRTC.EVENT.KICKED_OUT, event => {
        console.log('监听被踢出房间，原因如下 = ', event.reason)
        let reasonText = '您已被请出房间';
        if (event.reason === 'kick') {
          reasonText = '同名用户进入房间，您已被踢出';
          this.$router.push({
            path: '/consultingService'
          })
        } else if (event.reason === 'banned') {
          reasonText = '您已被请出房间';
          this.$router.push({
            path: '/consultingService'
          })
        } else if (event.reason === 'room-disband') {
          reasonText = '房间已被解散';
          this.kickedOutReason = event.reason
          this.destroyRoom()
        }
        this.$message.error(reasonText);
      });
      // 监听屏幕分享事件
      this.trtc.on(TRTC.EVENT.SCREEN_SHARE_STOPPED, () => {
        console.log('========= 停止屏幕分享了 ===  ');
        this.screenType = ''
        this.shareScreenStatus = false;
      });
    },

    // 管理视频DOM引用
    setVideoRef(el, data) {
      // console.log('el = ', el)
      // console.log('data = ', data)
      const {userId, streamType} = data
      const refKey = `remote_video_${userId}_${streamType}`;
      // console.log('refKey = ', refKey)
      this.$refs[refKey] = el;
      // console.log('this.$refs[refKey] = ', this.$refs[refKey])
    },

    // 打开/关闭麦克风
    async handleMic() {
      try {
        if (this.detailData.status === 2 && this.detailData.isShutByManager === 1) {
          this.$message.warning('运营人员 已关闭了咨询室')
          return
        }
        // if (this.micList.length === 0 && this.detailData.status === 2) {
        //   this.$message.warning('未检测到麦克风，您可刷新重试，或需安装个麦克风')
        //   return
        // }
        if (this.canModifyMic === false) {
          if (this.allAudioStatus === 'close') {
            this.$message.warning('房主已全体静音，您的麦克风无法开启');
          } else {
            this.$message.warning('您的麦克风已被房主关闭，无法开启');
          }
          return;
        }
        if (this.micStatus) {
          await this.trtc.stopLocalAudio();
        } else {
          await this.trtc.startLocalAudio();
          await this.refreshDeviceLists();
          this.$forceUpdate();
        }
        this.micStatus = !this.micStatus;
        // const index = this.memberScreenList.findIndex(item => item.userId === this.$store.state.UserInfo.id);
        // if (index !== -1) {
        //   this.$set(this.memberScreenList[index], 'micStatus', !this.memberScreenList[index].micStatus);
        // }
      } catch (error) {
        this.handleError(error, this.micStatus ? '关闭麦克风' : '开启麦克风');
      }
    },
    // 选择麦克风
    async handleSelectMic(micInfo) {
      try {
        console.log('micInfo = ', micInfo)
        this.curMicId = micInfo.deviceId
        await this.trtc.updateLocalAudio({option: {microphoneId: micInfo.deviceId}});
        this.micPopoverVisible = false
      } catch (error) {
        this.handleError(error, '切换麦克风设备');
      }
    },

    // 打开/关闭摄像头
    async handleCamera() {
      try {
        if (this.detailData.status === 2 && this.detailData.isShutByManager === 1) {
          this.$message.warning('运营人员 已关闭了咨询室')
          return
        }
        // if (this.cameraList.length === 0 && this.detailData.status === 2) {
        //   this.$message.warning('未检测到摄像头，您可刷新重试，或需安装个摄像头')
        //   return
        // }
        if (this.canModifyCamera === false) {
          if (this.allCameraStatus === 'close') {
            this.$message.warning('房主已全体静画，您的摄像头无法开启');
          } else {
            this.$message.warning('您的摄像头已被房主关闭，无法开启');
          }
          return;
        }
        if (this.cameraStatus) {
          await this.trtc.stopLocalVideo()
          // await this.trtc.updateLocalVideo({ mute: true });
          if (this.selectedUserScreen === this.$store.state.UserInfo.id) {
            this.selectedUserScreen = ''
          }
        } else {
          // if(this.detailData.allCameraTurnedOffFlag === 0 || !this.detailData.allCameraTurnedOffFlag) {
          const containerId = `remote_video_${this.$store.state.UserInfo.id}_main`;
          await this.trtc.startLocalVideo({
            view: this.$refs[containerId],
            publish: true,
            option: {
              small: '480p',
              profile: {
                width: 1920,
                height: 1080,
                frameRate: 24,
                bitrate: 4000,
              }
            }
          });
          await this.refreshDeviceLists();
          this.$forceUpdate();
          // }
          // await this.trtc.updateLocalVideo({ mute: false,publish: true });
        }
        this.cameraStatus = !this.cameraStatus;
        // const index = this.memberScreenList.findIndex(item => {
        //   return item.userId === this.$store.state.UserInfo.id
        // });
        // if (index !== -1) {
        //   this.$set(this.memberScreenList[index], 'cameraStatus', !this.memberScreenList[index].cameraStatus);
        // }
      } catch (error) {
        this.handleError(error, this.cameraStatus ? '关闭摄像头' : '开启摄像头');
      }
    },
    // 刷新设备列表
    async refreshDeviceLists() {
      try {
        // 获取麦克风列表
        const micList = await TRTC.getMicrophoneList();
        console.log("麦克风列表 = ", micList);
        if (micList.length === 0 || (micList.length === 1 && !micList[0].deviceId)) {
          this.micStatus = false;
          this.micList = [];
          this.curMicId = '';
        } else {
          // 过滤掉无效设备
          const validMics = micList.filter(item =>
            item.deviceId && item.deviceId.trim() !== '' && item.label
          );
          if (validMics.length > 0) {
            this.micList = validMics;
            // 如果当前选择的设备ID不在新列表中，选择第一个设备
            if (!this.micList.some(mic => mic.deviceId === this.curMicId)) {
              this.curMicId = this.micList[0]?.deviceId || '';
            }
          } else {
            this.micStatus = false;
            this.micList = [];
            this.curMicId = '';
          }
        }

        // 获取摄像头列表
        const cameraList = await TRTC.getCameraList();
        console.log("摄像头列表 = ", cameraList);
        if (cameraList.length === 0 || (cameraList.length === 1 && !cameraList[0].deviceId)) {
          this.cameraStatus = false;
          this.cameraList = [];
          this.curCameraId = '';
        } else {
          // 过滤掉无效设备
          const validCameras = cameraList.filter(item =>
            item.deviceId && item.deviceId.trim() !== '' && item.label
          );
          if (validCameras.length > 0) {
            this.cameraList = validCameras;
            // 如果当前选择的设备ID不在新列表中，选择第一个设备
            if (!this.cameraList.some(camera => camera.deviceId === this.curCameraId)) {
              this.curCameraId = this.cameraList[0]?.deviceId || '';
            }
          } else {
            this.cameraStatus = false;
            this.cameraList = [];
            this.curCameraId = '';
          }
        }
      } catch (error) {
        console.error('刷新设备列表失败:', error);
      }
    },
    // 选择摄像头
    async handleSelectCamera(cameraInfo) {
      try {
        console.log(('cameraInfo = ', cameraInfo))
        this.curCameraId = cameraInfo.deviceId
        await this.trtc.updateLocalVideo({option: {cameraId: cameraInfo.deviceId}});
        this.cameraPopoverVisible = false
      } catch (error) {
        this.handleError(error, '切换摄像头设备');
      }
    },
    // 共享屏幕
    async handleShareScreen() {
      try {
        if (this.detailData.status === 2 && this.detailData.isShutByManager === 1) {
          this.$message.warning('运营人员 已关闭了咨询室')
          return
        }
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          this.$message.warning('手机端暂不支持共享屏幕')
          return
        }
        if (this.screenType === 'sub' && this.shareScreenStatus === false) {
          this.$message.warning('当前有用户正在分享屏幕，请稍后再试')
          return
        }
        if (!this.shareScreenStatus) {
          this.screenType = 'sub'
          await this.trtc.startScreenShare({
            view: this.$refs.refSubScreen,
            option: {
              profile: {
                width: 2560,
                height: 1440,
                frameRate: 24,
                bitrate: 8000,
              }
            }
          });
          this.shareScreenStatus = true;
        } else {
          this.screenType = ''
          await this.trtc.stopScreenShare();
          this.shareScreenStatus = false;
        }
      } catch (error) {
        this.screenType = ''
        this.handleError(error, this.shareScreenStatus ? '停止屏幕共享' : '开始屏幕共享');
      }
    },

    // 全屏处理
    handleFullScreen() {
      if (this.isFullscreen) {
        this.exitFullscreen(this.$refs.refLargeScreen);
      } else {
        this.enterFullscreen(this.screenType === 'sub' ? this.$refs.refSubScreen : this.$refs.refLargeScreen, this.largeScreenUser.userId);
      }
    },
    // 实现 restartRemoteVideo 方法（必须）
    async restartRemoteVideo() {
      console.log('restartRemoteVideo this.screenType = ', this.screenType)
      if (!this.largeScreenUser || !this.largeScreenUser.userId) {
        return;
      }

      try {
        // 停止当前视频
        await this.trtc.stopRemoteVideo({
          userId: this.largeScreenUser.userId,
          streamType: this.screenType || 'main'
        });

        await new Promise(resolve => setTimeout(resolve, 200));

        // 重新开始
        await this.trtc.startRemoteVideo({
          userId: this.largeScreenUser.userId,
          streamType: this.screenType || 'main',
          view: this.screenType === 'sub' ? this.$refs.refSubScreen : this.$refs.refLargeScreen,
          option: { small: false }
        });
      } catch (error) {
        console.error('重新播放远程视频时出错:', error);
      }
    },

    handleMouseMove() {
      this.showControls = true
      this.startHideTimer()
    },
    startHideTimer() {
      clearTimeout(this.hideTimer)
      this.hideTimer = setTimeout(() => {
        this.showControls = false
      }, this.hideDelay)
    },
    hideControls() {
      this.showControls = false
      clearTimeout(this.hideTimer)
    },
    // 邀请
    handleInvite() {
      this.inviteDialogVisible = true
      this.inviteUrl = window.location.href + '&invite_code=' + this.detailData.inviteCode
    },
    async handleCopyUrl() {
      try {
        await navigator.clipboard.writeText(this.inviteUrl);
        this.$message.success('复制成功')
      } catch (err) {
      }
    },
    // 成员
    handleMember() {
      this.memberListVisible = !this.memberListVisible
    },
    // 聊天
    handleChat() {
      this.chatListVisible = !this.chatListVisible
      if (this.chatListVisible) {
        // 打开时重置所有状态
        this.shouldAutoScroll = true
        this.showNewMessageTip = false
        this.lastMessageTime = null

        this.getMessageList()
        this.getMessageListInterval = setInterval(() => {
          this.getMessageList();
        }, 3000);
      } else {
        if (this.getMessageListInterval) {
          clearInterval(this.getMessageListInterval)
          this.getMessageListInterval = null
        }
      }
    },
    // 聊天室-获取数据
    getMessageList() {
      const params = {
        meetingId: this.detailData.meetingId,
        showLimit: 1,
        showCount: 20
      }
      messageList(params).then(res => {
        if (res.code === 200) {
          const newData = res.data
          // 判断是否有新消息
          let hasNewMessage = false
          if (newData.length > 0) {
            // 获取最新消息的 发送时间
            const lastMessageTime = newData[newData.length - 1].sendTime ||
              newData[newData.length - 1].sendTime
            // 如果是第一次加载，或者有新消息
            if (this.lastMessageTime === null ||
              lastMessageTime !== this.lastMessageTime) {
              hasNewMessage = true
            }

            // 更新最后一条消息ID
            this.lastMessageTime = lastMessageTime
          }

          // 更新数据
          this.messageData = newData

          this.$nextTick(() => {
            const container = this.$refs.chatContainerRef;
            if (!container) return
            // 如果应该自动滚动（用户在底部）
            if (this.shouldAutoScroll) {
              container.scrollTop = container.scrollHeight;
              this.showNewMessageTip = false // 隐藏提示
            }
            // 如果有新消息但用户不在底部，显示提示
            else if (hasNewMessage && !this.shouldAutoScroll) {
              this.showNewMessageTip = true
            }
          })
        }
      })
    },
    // 监听滚动事件
    handleChatScroll() {
      const container = this.$refs.chatContainerRef;
      if (!container) return

      // 防抖处理
      if (this.scrollDebounceTimer) {
        clearTimeout(this.scrollDebounceTimer)
      }

      this.scrollDebounceTimer = setTimeout(() => {
        this.evaluateScrollPosition()
      }, 150)
    },

    evaluateScrollPosition() {
      const container = this.$refs.chatContainerRef;
      if (!container) return

      const scrollTop = container.scrollTop
      const scrollHeight = container.scrollHeight
      const clientHeight = container.clientHeight
      const distanceFromBottom = scrollHeight - scrollTop - clientHeight

      // 判断用户是否在底部
      const isAtBottom = distanceFromBottom <= this.scrollThreshold

      // 判断用户是否在向上滚动（查看历史消息）
      // 这里通过比较当前滚动位置和上次滚动位置来判断
      const isScrollingUp = scrollTop < this.lastScrollTop

      // 更新状态
      if (isAtBottom) {
        // 用户在底部，应该自动滚动
        this.shouldAutoScroll = true
        this.showNewMessageTip = false // 隐藏提示
      } else if (isScrollingUp) {
        // 用户向上滚动查看历史消息，暂停自动滚动
        this.shouldAutoScroll = false
      }

      // 保存当前滚动位置
      this.lastScrollTop = scrollTop
    },

    // 手动滚动到底部
    scrollToBottom() {
      this.shouldAutoScroll = true
      this.showNewMessageTip = false

      this.$nextTick(() => {
        const container = this.$refs.chatContainerRef;
        if (container) {
          container.scrollTop = container.scrollHeight
        }
      })
    },
    // 添加清除大屏的方法
    async clearLargeScreen() {
      if (!this.largeScreenUser.userId || !this.$refs.refLargeScreen.querySelector('video')) return;

      console.log('清除大屏，当前大屏用户:', this.largeScreenUser);

      const isCurrentLocal = this.largeScreenUser.userId === this.$store.state.UserInfo.id.toString()

      try {
        if (isCurrentLocal) {
          // 本地用户：停止大屏渲染，回到小屏
          // await this.trtc.stopLocalVideo();
          // 重新在小屏启动本地视频
          const containerId = `remote_video_${this.largeScreenUser.userId}_main`;
          if (this.$refs[containerId]) {
            await this.trtc.updateLocalVideo({
              view: this.$refs[containerId],
              option: {
                profile: {
                  width: 640,
                  height: 480,
                  frameRate: 24,
                  bitrate: 900,
                }
              }
            });
          }
        } else {
          // 远程用户：停止大屏渲染[citation:4]
          // await this.trtc.stopRemoteVideo({
          //   userId: this.largeScreenUser.userId.toString(),
          //   streamType: this.largeScreenUser.streamType
          // });
          // 重新在小屏启动远程视频[citation:1][citation:6]
          const containerId = `remote_video_${this.largeScreenUser.userId}_${this.largeScreenUser.streamType}`;
          const smallScreenContainer = this.$refs[containerId];

          if (smallScreenContainer) {
            await this.trtc.updateRemoteVideo({
              view: smallScreenContainer,
              userId: this.largeScreenUser.userId.toString(),
              streamType: this.largeScreenUser.streamType,
              option: {
                profile: {
                  width: 640,
                  height: 480,
                  frameRate: 24,
                  bitrate: 900,
                }
              }
            });
          }
        }
      } catch (error) {
        console.error('清除大屏失败:', error);
      }

      // 清除大屏DOM内容
      if (this.$refs.refLargeScreen) {
        this.$refs.refLargeScreen.innerHTML = '';
      }
    },

    // 选择大屏播放人
    async handleSelectUserScreen(operationType, userInfo, defaultLargeScreen) {
      try {
        console.log('操作类型:', operationType, '用户信息:', userInfo);
        const isLocalUser = userInfo.userId === this.$store.state.UserInfo.id;
        if (this.detailData.status === 2 && this.detailData.isShutByManager === 1) {
          this.$message.warning('运营人员 已关闭了咨询室')
          return
        }
        // if(this.detailData.status !== 2) {
        //   this.$message.warning('当前没在预约的时间内')
        //   return
        // }
        console.log('111111')
        if (operationType === 'FULL') {
          // 先清除当前大屏内容
          await this.clearLargeScreen();

          this.selectedUserScreen = userInfo.userId;

          if (isLocalUser) {
            // if (this.cameraList.length === 0) {
            //   this.$message.warning('未检测到摄像头，您可刷新重试，或需安装个摄像头');
            //   this.selectedUserScreen = '';
            //   return;
            // }
            // 在大屏启动本地视频
            await this.trtc.updateLocalVideo({
              view: this.$refs.refLargeScreen,
              // option: {
              //   profile: {
              //     width: 1920,
              //     height: 1080,
              //     frameRate: 24,
              //     bitrate: 4000,
              //   }
              // }
            });

          } else {
            await this.trtc.updateRemoteVideo({
              view: this.$refs.refLargeScreen,
              userId: userInfo.userId.toString(),
              streamType: userInfo.streamType || TRTC.TYPE.STREAM_TYPE_MAIN,
              option: {
                profile: {
                  width: 1920,
                  height: 1080,
                  frameRate: 24,
                  bitrate: 4000,
                }
              }
            });
          }
          // 更新大屏显示的用户信息
          this.largeScreenUser = {
            userId: userInfo.userId.toString(),
            streamType: userInfo.streamType || TRTC.TYPE.STREAM_TYPE_MAIN
          };

        } else {
          // EXIT_FULL 操作 - 切换回小屏幕
          console.log('EXIT_FULL操作，当前用户:', userInfo);
          const isLocalUser = userInfo.userId === this.$store.state.UserInfo.id;

          if (isLocalUser) {
            // 在小屏容器上重新启动本地视频
            const containerId = `remote_video_${userInfo.userId}_main`;
            if (this.$refs[containerId]) {
              await this.trtc.updateLocalVideo({
                view: this.$refs[containerId],
                // option: {
                //   small: '480p',
                //   profile: {
                //     width: 640,
                //     height: 480,
                //     frameRate: 24,
                //     bitrate: 900,
                //   }
                // }
              });
            }
          } else {
            // 在小屏容器上重新启动远程视频
            const containerId = `remote_video_${userInfo.userId}_main`;
            const smallScreenContainer = this.$refs[containerId];
            if (smallScreenContainer) {
              await this.trtc.updateRemoteVideo({
                view: smallScreenContainer,
                userId: userInfo.userId.toString(),
                streamType: userInfo.streamType || TRTC.TYPE.STREAM_TYPE_MAIN,
                option: {
                  small: '480p',
                  profile: {
                    width: 640,
                    height: 480,
                    frameRate: 24,
                    bitrate: 900,
                  }
                }
              });
            }
          }

          // 更新状态
          this.selectedUserScreen = '';
          this.largeScreenUser = {userId: '', streamType: ''};
        }
      } catch (error) {
        this.selectedUserScreen = '';
        if (defaultLargeScreen === true) {
          return
        }
        this.handleError(error, '切换视频显示');
      }
    },
    // 列表-举手 （同意打开麦克风权限）
    async handleListHand(memberInfo) {

    },
    async handleListMic(memberInfo, memberIndex) {
      console.log('memberInfo = ', memberInfo)
      try {
        if (memberInfo.userId === this.$store.state.UserInfo.id) {
          await this.handleMic()
        } else {
          // [事件类型：3强制操作指定人员麦克风,userId，操作类型：0打开/1关闭]
          // const unit8Array = new Uint8Array([3,memberInfo.userId,memberInfo.micStatus ? 1 : 0]);
          // console.log('列表-麦克风 unit8Array = ',unit8Array)
          // await this.trtc.sendSEIMessage(unit8Array.buffer);
          const params = {
            userId: memberInfo.userId,
            micStatus: !memberInfo.micStatus,
            operationType: 'mic'
          }
          await this.trtc.sendCustomMessage({
            cmdId: 3,
            data: new TextEncoder().encode(JSON.stringify(params)).buffer
          });
          let text = ''
          if (memberInfo.userId === this.detailData.consulterId) {
            text = '预约人 ' + memberInfo.phone.slice(-4)
          } else {
            text = memberInfo.phone.slice(-4)
          }
          if (params.micStatus === true) {
            this.$message.warning('已解除了对 ' + text + ' 的麦克风的关闭')
            this.$set(this.memberScreenList[memberIndex], 'micStatus', true);
            this.$set(this.memberScreenList[memberIndex], 'handStatus', false);
          }
          if (params.micStatus === false) {
            this.$message.warning('已关闭 ' + text + ' 的麦克风')
            this.$set(this.memberScreenList[memberIndex], 'micStatus', false);
          }
          console.log('params.micStatus = ', params.micStatus)
          console.log('params.handStatus = ', params.handStatus)
          // if(!memberInfo.micStatus && memberInfo.handStatus === true) {
          //   const index = this.memberScreenList.findIndex(item => {
          //     return item.userId === memberInfo.userId
          //   });
          //   if (index !== -1) {
          //     this.$set(this.memberScreenList[index], 'handStatus', false);
          //   }
          // }
        }
      } catch (error) {
        console.error(error)
      }
    },
    // 列表-摄像头
    async handleListCamera(memberInfo, memberIndex) {
      try {
        console.log('memberInfo = ', memberInfo)
        if (memberInfo.userId === this.$store.state.UserInfo.id) {
          this.handleCamera()
        } else {
          // [事件类型：4强制操作指定人员摄像头,userId，操作类型：0打开/1关闭]
          // const unit8Array = new Uint8Array([4,memberInfo.userId,memberInfo.cameraStatus ? 1 : 0]);
          // console.log('列表-摄像头 unit8Array = ',unit8Array)
          // console.log('列表-摄像头 unit8Array = ',unit8Array.buffer)
          // await this.trtc.sendSEIMessage(unit8Array.buffer);
          const params = {
            userId: memberInfo.userId,
            cameraStatus: !memberInfo.cameraStatus,
            operationType: 'camera'
          }
          await this.trtc.sendCustomMessage({
            cmdId: 4,
            data: new TextEncoder().encode(JSON.stringify(params)).buffer
          });
          let text = ''
          if (memberInfo.userId === this.detailData.consulterId) {
            text = '预约人 ' + memberInfo.phone.slice(-4)
          } else {
            text = memberInfo.phone.slice(-4)
          }
          if (params.cameraStatus === true) {
            this.$message.warning('已解除了对 ' + text + ' 的摄像头的关闭')
            this.$set(this.memberScreenList[memberIndex], 'cameraStatus', true);
          }
          if (params.cameraStatus === false) {
            this.$message.warning('已关闭 ' + text + ' 的摄像头')
            this.$set(this.memberScreenList[memberIndex], 'cameraStatus', false);
          }
        }
      } catch (error) {
        this.handleError(error, '操作成员摄像头');
      }
    },
    // 全部 静音/解除静音
    async handleAllMic() {
      try {
        const text = this.allAudioStatus === 'open' ? '关闭所有学员的麦克风吗？' : '解除对所有学员麦克风的关闭状态吗？'
        this.$confirm(text).then(async () => {
          // receivedArray[0] 事件类型： 【0 切换大小屏幕】、【1 全体静音】、【2 全体静画】、【3 强制操作指定人员麦克风】、【4、强制操作指定人员摄像头】
          // const operationType = this.allAudioStatus === 'open' ? 1 : 0
          // const unit8Array = new Uint8Array([1, operationType]);
          // await this.trtc.sendSEIMessage(unit8Array.buffer);
          const params = {
            allMicStatus: this.allAudioStatus === 'open' ? 1 : 0,
            operationType: 'allMic'
          }
          await this.trtc.sendCustomMessage({
            cmdId: 1,
            data: new TextEncoder().encode(JSON.stringify(params)).buffer
          });
          await switchMicrophone({meetingId: this.detailData.meetingId})
          this.allAudioStatus = this.allAudioStatus === 'open' ? 'close' : 'open'
          for (let i = 0; i < this.memberScreenList.length; i++) {
            this.$set(this.memberScreenList[i], 'micStatus', this.allAudioStatus === 'open');
          }
        }).catch(() => {
        })
      } catch (error) {
        this.handleError(error, '全体麦克风操作');
      }
    },
    // 全部 静画/解除静画
    async handleAllCamera() {
      try {
        const text = this.allCameraStatus === 'open' ? '关闭所有学员的摄像头吗？' : '解除了对所有学员摄像头的关闭状态吗？'
        this.$confirm(text).then(async () => {
          // receivedArray[0] 事件类型： 【0 切换大小屏幕】、【1 全体静音】、【2 全体静画】、【3 强制操作指定人员麦克风】、【4、强制操作指定人员摄像头】
          // const operationType = this.allCameraStatus === 'open' ? 1 : 0
          // const unit8Array = new Uint8Array([2,operationType]);
          // await this.trtc.sendSEIMessage(unit8Array.buffer);
          const params = {
            allCameraStatus: this.allCameraStatus === 'open' ? 1 : 0,
            operationType: 'allCamera'
          }
          await this.trtc.sendCustomMessage({
            cmdId: 2,
            data: new TextEncoder().encode(JSON.stringify(params)).buffer
          });
          await switchCamera({meetingId: this.detailData.meetingId})
          this.allCameraStatus = this.allCameraStatus === 'open' ? 'close' : 'open'
          for (let i = 0; i < this.memberScreenList.length; i++) {
            this.$set(this.memberScreenList[i], 'cameraStatus', this.allCameraStatus === 'open');
          }
        }).catch(() => {
        })
      } catch (error) {
        this.handleError(error, '全体摄像头操作');
      }
    },
    // 举手
    async handleHand(memberInfo) {
      try {
        console.log('memberInfo = ', memberInfo)
        // const unit8Array = new Uint8Array([5,memberInfo.userId,memberInfo.handStatus === true ? 0 : 1]);
        // await this.trtc.sendSEIMessage(unit8Array.buffer)
        const params = {
          userId: memberInfo.userId,
          handStatus: !memberInfo.handStatus,
          operationType: 'hand'
        }
        await this.trtc.sendCustomMessage({
          cmdId: 5,
          data: new TextEncoder().encode(JSON.stringify(params)).buffer
        });
        const index = this.memberScreenList.findIndex(item => {
          return item.userId === this.$store.state.UserInfo.id
        });
        if (index !== -1) {
          this.$set(this.memberScreenList[index], 'handStatus', params.handStatus);
        }
      } catch (error) {
        this.handleError(error, '发送举手状态');
      }
    },
    //聊天室-发送
    handleSendMessage() {
      const params = {
        meetingId: this.detailData.meetingId,
        content: this.sendMessage
      }
      consultMeetingMessage(params).then(res => {
        if (res.code === 200) {
          setTimeout(() => {
            this.getMessageList()  // 延迟500ms再拉取列表
          }, 500);
          this.sendMessage = ''
        }
      })
    },
    // 聊天室-查看全部
    handleViewAll() {
      const routeData = this.$router.resolve({
        path: '/chatHistory',
        query: {meetingId: this.detailData.meetingId, number: this.detailData.appointmentId}
      })
      window.open(routeData.href, '_blank')
    },
    // 定时更新实时消耗
    intervalRefreshConsume() {
      this.refreshConsumeInterval = setInterval(() => {
        describe(this.$route.query.appointmentId).then(async res => {
          if (res.code === 200) {
            this.detailData = res.data
            this.$emit('dataUpdate', res.data);
            if (this.detailData.status === 2 && !this.trtc && this.userSig && this.detailData.isShutByManager === 0) {
              await this.initTRTC(this.userInfo.userId.toString(), this.userSig, this.detailData.meetingId)
              if (!this.joinRoomInterval) {
                this.intervalJoinRoom()
              }
            }
            if ((this.detailData.isShutByManager === 1 || this.detailData.status === 3 || this.detailData.status === 4 || this.detailData.status === 5) && this.trtc) {
              this.destroyRoom()
            }
          }
        })
      }, 3000);
    },
    // 进房后
    intervalJoinRoom() {
      this.joinRoomInterval = setInterval(() => {
        consultMeetingHealth({
          appointmentId: this.detailData.appointmentId || this.$route.query.appointmentId,
          inviteCode: this.$route.query.invite_code || undefined
        }).then(res => {
        })
      }, 3000);
    },
    async destroyRoom() {
      // 离开房间并销毁实例
      if (this.trtc) {
        await this.trtc.stopLocalAudio();
        await this.trtc.stopLocalVideo();
        await this.trtc.exitRoom();
        this.trtc.destroy();
        this.trtc = null;
      }
      if (this.joinRoomInterval) {
        clearInterval(this.joinRoomInterval)
        this.joinRoomInterval = null
      }
      this.memberScreenList = [
        {
          userId: '',
          userType: '承约人',
          userName: '承约人昵称',
          streamType: 'main',
          micStatus: true,
          cameraStatus: true
        },
        {
          userId: '',
          userType: '预约人',
          userName: '预约人昵称',
          streamType: 'main',
          micStatus: true,
          cameraStatus: true,
          handStatus: false
        }
      ]
      const userInfoRes = await getUserEmployeeInfoById()
      this.userInfo = userInfoRes.data
      if (this.userInfo.userId === this.detailData.consultantUserId) { // 判断是否是受询人
        this.$set(this.memberScreenList, 0, {
          ...this.userInfo,
          streamType: 'main',
          micStatus: false,
          cameraStatus: false,
          isManage: this.$store.state.UserInfo.isManage
        })
      } else if (this.userInfo.userId === this.detailData.consulterId) { // 判断是否是预约人
        this.$set(this.memberScreenList, 1, {
          ...this.userInfo,
          streamType: 'main',
          handStatus: false,
          micStatus: false,
          cameraStatus: false,
          isManage: this.$store.state.UserInfo.isManage
        })
      } else {
        this.memberScreenList.push({
          ...this.userInfo,
          streamType: 'main',
          handStatus: false,
          micStatus: false,
          cameraStatus: false,
          isManage: this.$store.state.UserInfo.isManage
        })
      }
    }
  },
  beforeDestroy() {
    this.destroyRoom()

    clearInterval(this.getMessageListInterval)
    this.getMessageListInterval = null

    if (this.refreshConsumeInterval) {
      clearInterval(this.refreshConsumeInterval)
      this.refreshConsumeInterval = null
    }
  }
}
</script>

<style lang="scss">
.consulting-room {
  .large-screen-action {
    width: 1200px;
    height: 117px;
    background-color: #FFFFFF;
    font-family: PingFang HK, PingFang HK;
    font-weight: 400;
    font-size: 20px;
    padding: 25px 32px 16px 32px;
    margin-bottom: 32px;
    display: flex;
    justify-content: space-between;

    .action-left, .action-right {
      display: flex;
      gap: 70px;
    }

    .action-btn-item {
      display: flex;
    }

    .action-btn {
      width: 80px;
      height: 76px;
      text-align: center;
      cursor: pointer;
      display: grid;
      justify-items: center;

      .btn-icon {
        width: 32px;
        height: 32px;
        font-size: 32px;
        margin-bottom: 17px;
      }
    }

    .action-btn-more {
      display: flex;
      align-items: center;
    }
  }

  .member-row {
    height: 100%;
    width: 100%;
    display: flex;
    gap: 20px;

    .sub-title {
      font-family: PingFang HK, PingFang HK;
      font-weight: 600;
      font-size: 18px;
      color: #333333;
      margin-bottom: 12px;
      display: flex;
      justify-content: space-between;

      .el-icon-close {
        color: #E6E6E6;
        font-size: 20px;
        cursor: pointer;
      }
    }

    .member-screen-container {
      flex: 1;
      min-width: 0;
    }

    .member-screen {
      width: 100%;
    }

    .member-list, .chat-list {
      width: 290px;
      height: 365px;
      padding: 16px 24px;
      background: #FFFFFF;
      border-radius: 8px 8px 8px 8px;
      flex-shrink: 0;
      overflow: auto;
    }

    .member-list {
      display: flex;
      flex-direction: column;
      position: relative;

      .member-items-container {
        flex: 1;
        overflow-y: auto;
        margin-bottom: 16px;
      }

      .member-item {
        display: flex;
        //justify-content: space-around;
        justify-content: flex-start;
        align-items: center;
        font-size: 16px;
        font-family: PingFang HK, PingFang HK;

        .member-head {
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;

          .member-head-icon {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            border: 1px solid #EEEEEE;
          }
        }

        .member-name {
          //width: 77px;
          height: 22px;
          margin-left: 8px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          //max-width: 77px;
          display: flex;
          margin-right: 14px;
          flex: 1;
          gap: 10px;
        }

        .member-name:first-child {
          max-width: 87px;
          overflow: hidden;
        }

        .member-action {
          //width: 115px;
          display: flex;
          gap: 10px;

          .btn-icon {
            width: 24px;
            height: 24px;
            font-size: 24px;
            color: #4F4F4F;
          }

          .el-icon-turn-off-microphone {
            color: #999999;
          }
        }
      }

      .member-list-footer {
        display: flex;
        justify-content: center;
        padding-top: 16px;
        position: sticky;
        bottom: 0;
        background: white;
        z-index: 1;
        //border-top: 1px solid #f0f0f0;
        .custom-button {
          width: 96px;
          height: 34px;
          //background: #5AD3CD;
          border-radius: 60px;
          font-family: PingFang HK;
          font-weight: 600;
          font-size: 16px;
          color: #FFFFFF;
          padding: 0;

          & + .custom-button {
            margin-left: 16px;
          }
        }
      }
    }

    .chat-list {
      padding: 14px 12px 16px 12px;

      .view-all {
        width: 96px;
        height: 29px;
        padding: 0px;
        border-radius: 60px;
        font-size: 18px;
      }

      .chat-container {
        width: 266px;
        height: 234px;
        background: #F5F5F5;
        border-radius: 8px 8px 8px 8px;
        overflow-y: auto;
        margin-bottom: 16px;
        padding: 16px;

        .other {
          text-align: left;
        }

        .current {
          text-align: right;
        }

        .chat-item {
          margin-bottom: 9px;

          .avatar-row-current-user, .avatar-row-other-user {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 10px;

            .user-name {
              color: #999999;
              fong-size: 14px;
            }
          }

          .avatar-row-current-user {
            justify-content: flex-end;
          }

          .avatar-row-other-user {
            justify-content: flex-start;
          }

          .message-content-current-user, .message-content-other-user {
            border-radius: 12px 12px 12px 12px;
            font-family: PingFang HK, PingFang HK;
            font-weight: 400;
            font-style: normal;
            text-transform: none;
            padding: 6px 12px;
            display: inline-block;
            //margin-left: 40px;
            word-break: break-all;
          }

          .message-content-current-user {
            color: #FFFFFF;
            background: #5AD3CD;
            position: relative;
            text-align: left;

            .icon-top {
              width: 10px;
              height: 10px;
              position: absolute;
              top: -6px;
              right: 10px;
            }
          }

          .message-content-other-user {
            color: #000000;
            background: #fff;
            position: relative;
            text-align: left;

            .icon-top {
              width: 10px;
              height: 10px;
              position: absolute;
              top: -6px;
              left: 10px;
            }
          }
        }

      }

      .chat-send-row {
        display: flex;
        justify-content: space-between;
        position: relative;

        .send-input {
          width: 187px;
          height: 44px;

          input {
            border-color: #D7D7D7;
            border-radius: 46px;
          }
        }

        .send-button {
          width: 67px;
          height: 44px;
          border-radius: 46px 46px 46px 46px;
        }

        .has-message {
          background: #5AD3CD;
          color: #fff;
        }

        .no-message {
          border-color: #D7D7D7;
          background: #fff;
          color: #999999;
        }

        .new-message-tip {
          position: absolute;
          bottom: 65px;
          left: 50%;
          transform: translateX(-50%);
          background-color: #F5F5F5;
          color: #999999;
          padding: 5px 10px;
          border-radius: 20px;
          cursor: pointer;
          font-size: 10px;
          font-weight: bold;
          z-index: 10;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
          animation: fadeIn 0.3s ease;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateX(-50%) translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
          }
        }
      }
    }

    @media (max-width: 1200px) {
      .member-row {
        flex-wrap: wrap;
      }
    }
  }
}
</style>
<style lang="scss">
.fullscreen-container {
  position: relative;
  width: 1200px;
  height: 720px;
  background-color: #222222;

  &.is-fullscreen {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw !important; // 覆盖原有宽度
    height: 100vh !important; // 覆盖原有高度
    z-index: 9999;
    background-color: #222222;
    margin: 0;

    .video-container {
      width: 100%;
      height: 100%;
    }
  }
}

.video-container {
  width: 100%;
  height: 100%;

  .large-screen {
    width: 100%;
    height: 100%;

    video {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .kicked-out {
    display: flex;
    align-items: center;
    justify-content: center;

    .kicked-out-reason {
      height: 30px;
      font-family: PingFang HK, PingFang HK;
      font-weight: 600;
      font-size: 26px;
      color: #FFFFFF;
      display: grid;
      align-items: center;
      justify-content: center;
      text-align: center;

      .el-image {
        vertical-align: sub;
      }
    }
  }
}

.controls-bar {
  position: absolute; // 非全屏时相对定位
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 20px;
  z-index: 100;

  // 全屏时使用fixed定位
  .is-fullscreen & {
    position: fixed;
  }
}

.exit-fullscreen-btn {
  color: rgba(255, 255, 255, 0.5);
  padding: 8px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 20px;

  .el-image {
    margin-right: 8px;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.invite-dialog {
  text-align: center;

  .invite-info-container {
    display: flex;
    justify-content: center;
    align-items: center;

    .invite-url {
      margin-right: 16px;
    }

    .copy-btn {
      width: 67px;
      height: 34px;
      background: #5AD3CD;
      border-radius: 60px;
      font-family: PingFang HK;
      font-weight: 600;
      font-size: 16px;
      color: #FFFFFF;
      padding: 0;
    }
  }

  .invite-title {
    font-size: 22px;
    font-weight: bold;
    margin-top: 16px;

    .invite-prompt {
      margin-top: 16px;
      font-size: 12px;
      color: #999999;
      font-weight: unset;
    }
  }
}
</style>

<style lang="scss">
.member-screen {
  width: auto;
  max-width: 1200px;
  height: 365px;
  background: #FFFFFF;
  border-radius: 8px;
  padding: 24px 32px;
  padding-right: 0px;
  display: flex;
  flex-direction: column;

  .page-title {
    font-family: PingFang HK;
    font-weight: 600;
    font-size: 20px;
    color: #333333;
    margin-bottom: 16px;
    flex-shrink: 0; /* 防止标题被压缩 */
  }

  .screen-container {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
  }

  .screen-content {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    align-content: flex-start;
    min-width: min-content;
  }

  .screen-item {
    .item-video {
      width: 246px;
      height: 148px;
      background: #EEEEEE;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
    }

    .user-row {
      width: 100%;
      height: 32px;
      display: flex;
      align-items: center;
      margin-top: 12px;

      .user-icon {
        width: 32px;
        height: 32px;
        border: 1px solid #EEEEEE;
        border-radius: 50%;
        flex-shrink: 0;
      }

      .user-name {
        flex: 1;
        margin: 0 8px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 150px;
      }

      .user-action {
        flex-shrink: 0;
        margin-left: auto;

        .el-image {
          width: 24px;
          height: 24px;
        }
      }
    }
  }
}

/* 确保视频容器可见 */
.screen-item .item-video {
  position: relative;
  width: 246px;
  height: 148px;
  background: #EEEEEE !important; /* 改为黑色背景便于观察 */
  overflow: hidden;
}

/* 强制视频元素样式 */
.screen-item video {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
  background: #EEEEEE;
  display: block !important; /* 解决可能的inline元素问题 */
}
</style>
<style lang="scss">
.custom-popover-select {
  .custom-popover-select-option {
    display: flex;
    gap: 20px;
    justify-content: space-between;
    font-size: 28px;
    cursor: default;
  }

  .custom-popover-select-option:hover, .option-active {
    color: #22eed3;
  }

}
</style>
